/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RegionPaginateResponse } from '../../models/region-paginate-response';

export interface GetRegionIndex$Params {

/**
 * Pagination offset
 */
  page?: number;

/**
 * Pagination limit
 */
  limit?: number;

/**
 * Pagination order field ascending
 */
  orderAsc?: 'id' | 'label';

/**
 * Pagination order field descending
 */
  orderDesc?: 'id' | 'label';

/**
 * Filter Region id
 */
  id?: number;

/**
 * Filter Region label
 */
  label?: string;
}

export function getRegionIndex(http: HttpClient, rootUrl: string, params?: GetRegionIndex$Params, context?: HttpContext): Observable<StrictHttpResponse<RegionPaginateResponse>> {
  const rb = new RequestBuilder(rootUrl, getRegionIndex.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('orderAsc', params.orderAsc, {});
    rb.query('orderDesc', params.orderDesc, {});
    rb.query('id', params.id, {});
    rb.query('label', params.label, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RegionPaginateResponse>;
    })
  );
}

getRegionIndex.PATH = '/v1/region';
